import DeviceType from "./DeviceType.js";
import DeviceTypeId from "./DeviceTypeId.js";
import FirmwareApplicationId from "./FirmwareApplicationId.js";
import Id from "./Id.js";
import Metadata from "./Metadata.js";
import Name from "./Name.js";
import ProjectId from "./ProjectId.js";
import StartTime from "./StartTime.js";
import State from "./State.js";
import Type from "./Type.js";
import UpgradeOptions from "./UpgradeOptions.js";
import FirmwareApplication from "./FirmwareApplication.js";
import LoadBalancerEnabled from "./LoadBalancerEnabled.js";
import UpgradeWindowsEnabled from "./UpgradeWindowsEnabled.js";
import DeviceGroups from "./DeviceGroups.js";
import PercentToGetApplication from "./PercentToGetApplication.js";
export default {
  DeviceType,
  DeviceTypeId,
  FirmwareApplicationId,
  Id,
  Metadata,
  Name,
  ProjectId,
  StartTime,
  State,
  Type,
  UpgradeOptions,
  FirmwareApplication,
  LoadBalancerEnabled,
  UpgradeWindowsEnabled,
  DeviceGroups,
  PercentToGetApplication
};
export { DeviceType, DeviceTypeId, FirmwareApplicationId, Id, Metadata, Name, ProjectId, StartTime, State, Type, UpgradeOptions, FirmwareApplication, LoadBalancerEnabled, UpgradeWindowsEnabled, DeviceGroups, PercentToGetApplication };